import { ContentProvider } from "@/models/contentprovider";
import { ModelValidation } from "@/models/modelvalidation";

export interface IContextualContent {
    uuid?: string | null;
    cnam?: string | null;
    name?: string | null;
    status?: string | null;
    contentProviderUuid?: string | null;
    notificationMessageUuid?: string | null;
    notificationMessageUuidFromServer?: string | null;
    type?: string;

}

export class ContextualContent extends ModelValidation {
    public uuid!: string | null;
    public cnam!: string | null;
    public name!: string | null;
    public status!: string | null;
    public contentProviderUuid!: string | null;
    public notificationMessageUuid!: string | null;
    public notificationMessageUuidFromServer!: string | null;
    public type!: string;

    constructor(contextualContent: IContextualContent) {
        super();

        if (!contextualContent) {
            throw new Error("Cannot construct ContextualContent from falsey IContextualContent");
        }

        this.uuid = contextualContent.uuid || null;
        this.cnam = contextualContent.cnam || "";
        this.name = contextualContent.name || "";
        this.status = contextualContent.status || "draft";
        this.contentProviderUuid = contextualContent.contentProviderUuid || null;
        this.notificationMessageUuid = contextualContent.notificationMessageUuid || null;
        this.notificationMessageUuidFromServer = contextualContent.notificationMessageUuid || null;
        this.type = contextualContent.type || "";
    }

    public static empty(): ContextualContent {
        return new ContextualContent({});
    }

    public toNewContextualContentDto(): IContextualContent {
        return {
            cnam: this.cnam,
            name: this.name,
            status: this.status
        };
    }

    public toNewContextualContentWithPushNotificationDto(): IContextualContent {
        return {
            name: "Push Notification Message Added: " + new Date().toString(),
            type: "notification",
            notificationMessageUuid: this.notificationMessageUuid,
        };
    }

    public toNewContextualContentWithCleanNotificationDto(): IContextualContent {
        return {
            name: "Clean Notification Message Added: " + new Date().toString(),
            type: "notification",
            notificationMessageUuid: this.notificationMessageUuid,
        };
    }

    public toUpdateContextualContentWithPushNotificationDto(): IContextualContent {
        return {
            name: "Push Notification Message Updated: " + new Date().toString(),
            type: "notification",
            notificationMessageUuid: this.notificationMessageUuid,
        };
    }

    public toUpdateContextualContentWithCleanNotificationDto(): IContextualContent {
        return {
            name: "Clean Notification Message Updated: " + new Date().toString(),
            type: "notification",
            notificationMessageUuid: this.notificationMessageUuid,
        };
    }
}
